export const zhCN = {
  // 充值相关
  deposit: {
    title: '充值',
    chain: '链',
    asset: '资产',
    amount: '数量',
    available: '可用',
    equity: '总资产',
    confirmDeposit: '充值确认',
    switchNetwork: '切换网络',
    max: '最大',
    arrivalTime: '到账时间',
    minDeposit: '最小充值金额',
    minDepositParsed: '最少充值 {{amount}} {{token}}',
    maxDeposit: '最大充值金额',
    depositTipFor25w:
      '单笔充值金额上限为 200,000。若充值金额大于200,000，请使用Ethereum链充值。',
    depositAllTip:
      '仅支持发送 {{coin}} ({{v}}) 资产到此地址。\n 充值金额大于 200,000 时，到账时间存在一定延迟，请耐心等待。',
    enableSystemProWithToken: '在{{network}}上启用{{token}}',
    enableTokenDesc: '您首次在{{network}}上存款时必须启用{{token}}。',
    enableWithToken: '启用 {{token}}',
    arrivaltimeTooltip1:
      '资金约在 {{v}} 分钟 内 (达到 {{v1}} 个区块确认后) 到账。',
    arrivaltimeTooltip2:
      '预计时间是根据历史数据计算所得，仅供参考。网络拥堵可能会导致实际到账时间变长。',
    arrivalEstimated: '≈ {{v}}分钟',
    availableDesc: '您可以充值的最大金额。当可用为0或负数时，无法进行充值。',
    noPrivateKeyWalletWarning:
      '请勿使用无私钥钱包进行充值，无私钥钱包充值会导致资金损失且无法追回。',
    layerZeroDepositTip:
      '系统会根据充值资金实际情况，将您的充值通过LayerZero完成。',
    layerZeroDepositTipExceedPool:
      '由于充值资金大于资金池，将通过LayerZero完成您的充值。',
    layerZeroDepositTipGte200k:
      '由于充值资金大于等于200,000 USDT，将通过LayerZero完成您的充值。',
    layerZeroDepositButton: '使用LayerZero充值',
  },
  withdraw: {
    noticeDesc:
      '普通提现是一个两步过程。 此步骤将发起您的提现请求，并将在 Layer2 进行处理。 一旦资金准备就绪（可能需要最多 4 小时），您将收到一条将资金提现到钱包的通知。受链同步等情况影响下，时长可能到 48 小时。您需要自行承担交易 gas 费用。',
    crossChainTips:
      '跨链提币需在 L2（通过零知识证明）进行验证。提币过程最多约需2小时。相关链的资产池中需有充足的资金来处理跨链提币，其间还将产生矿工费。 edgeX 将收取一定的手续费作为矿工费。',
    commonWithdraw: '提现说明',
    withdraw: '提现',
    speed: '速度',
    confirmWithdraw: '提现确认',
    speedNote: '处理时间：',
    speedNoteSpeed1: '用时约8分钟',
    speedNoteSpeed2: '用时约 2-4 小时',
    speedNoteSpeed3: '用时约4小时',
    receiverAddress: '接收地址',
    fee: '手续费',
    feeRate: '费率',

    withdrawlAmount: '提现金额',
    amountToReceive: '到账金额',
    invalidReceiverAddress: '接收地址不能为空',
    availableDesc: '您可以提现的最大金额。当可用为0或负数时，无法进行提现。',
    feeCalculationTip:
      '提现手续费按照提现金额乘以费率计算，最低为1 USDT/USDC。费率会根据链上实际情况进行调整。',
    crossChainPoolBalance: '跨链资金池余额',
    poolBalance: '资金池余额',
    poolBalanceInsufficientTip:
      '提现金额大于资金池余额，无法进行提现。请选择资金池余额充足的选项。',
  },
  account: {
    title: '账户',
    perpetual: '合约账户',
    spot: '现货账户',
  },
}

export default zhCN
export type TranslationKeys = typeof zhCN
